// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"4f447e86","271":"bb7a3e17","304":"4cdce8e4","473":"51c3d221","536":"3f48115c","609":"0d7b4d9d","678":"86e2545d","900":"6095eba5","926":"3bb2a8a5","932":"5e99444c","938":"70313487","956":"d0a1c3b5"}[chunkId] + ".chunk.js";
};